<template>
  <!-- 课程18 -->
  <div class="lessonTen">
    <div class="web_content">
      <div class="title">第6章 AI的影响（18 总结）</div>
      <div class="content">
        我们对过去了解的越多，对未来的准备就越好。
        <br />在第 6 章中，我们将介绍以下部分。
      </div>
    <div class="content">
        一、
        <span  @click="jumpOne" style="color:#0090ff;cursor: pointer;" class="index">关于预测未来 （0/1）</span>
      </div>
      <div class="content">
        二、
        <span  @click="jumpTow" style="color:#0090ff;cursor: pointer;" class="index">人工智能的社会影响 （0/1）</span>
      </div>
      <div class="content">
        三、
        <span @click="jumpThree" style="color:#0090ff;cursor: pointer;" class="index">总结 （---）</span>
      </div>

      <div class="title-child" id="productId">第3节 总结</div>

      <div class="title-child-bold">决定我们的社会如何适应人工智能带来的变化的最重要因素不是技术，是政治。</div>
      <div
        class="content"
      >我们所了解的关于人工智能的一切都表明，未来是光明的。我们将获得新的更好的服务，提高生产力将带来积极的总体成果，但前提是我们要认真考虑社会影响，确保AI的力量被用于共同利益。</div>

      <div class="title-child-bold">一、我们需要做些什么来确保取得积极的效果？</div>
      <div class="content">
        我们有很多工作要做。
        <br />1. 我们需要避免算法偏差，以便能够减少而不是增加歧视。
        <br />2. 我们还需要学会对自己所看到的事物持批判态度，因为眼见并非一定为实；要努力开发可帮助我们检测欺诈行为的AI方法，而不仅仅是使制造更真实的虚假内容变得容易。
        <br />3. 我们需要制定法规，以确保人们享有隐私权，任何侵犯隐私权的行为均应严加惩处。
        <br />4. 我们还需要找到新的方式，让每个人都能分享这些好处，而不是创造一个AI精英，那些能够负担得起最新AI技术并利用它获得前所未有的经济收益的人。这需要谨慎的政治判断（注意，政治判断指的是关于政策的决定，这与选举中谁投谁的票或个别政客和政党的来来往往几乎没有关系）。
      </div>

      <div class="content-red">【注意】政策的重要性</div>

      <div class="content">
        决定我们的社会如何适应工作发展和AI带来的变化的最重要的因素不是技术，是政治。
        <br />对AI使用的监管必须遵循民主原则，每个人都必须对我们未来想要建立什么样的社会有平等的发言权。实现这一目标的唯一途径，是让所有人都能免费获得有关技术的知识。显然，在任何给定话题上，总会有专家，他们比我们其他人都更了解这个话题，但我们至少应该有可能批判性地评估他们在说什么。
        <br />您在我们这里学到的东西，为您提供了有关AI的基本背景，支持了“平等发言权”这一目标，让我们可以对AI及其含义进行理性的讨论。
      </div>

      <div class="title-child-bold">二、我们作为个人的角色</div>

      <div
        class="content"
      >也许您还记得，我们通过讨论影响我们一生的杰出AI应用，来激发对AI的研究。我们重点介绍了三个示例：自动驾驶汽车，推荐系统以及图像和视频处理。在课程中，我们还讨论了有助于当前技术转型的其他各种应用。</div>
      <div class="content-red">【注意】隐藏的目标</div>

      <div class="content">
        我们还有一个隐藏的目标。我们希望给您一个机会，让您体验到学习的快感，以及当一些原本复杂而神秘的事物变得简单的时候，那种不言而喻的喜乐时刻。这是满足我们好奇心的时刻。但是这种满足感是暂时的，在找到一个问题的答案后不久，我们将问下一个问题，那又怎样？然后呢？
        <br />如果我们成功实现了这一目标，我们就激发了您学习的兴趣。我们希望您能继续学习，找到其他课程和有关AI的更多信息，以及您感兴趣的其他话题。为了帮助您进行探索，我们收集了一些有用且有趣的AI资料。
        <br />现在，您可以了解AI中发生的事情，以及为确保其正确使用而正在做或将要做的事情。您应该这样做，每当您觉得应该讨论，或者应该去寻求机会时，不要等待别人的反应，大胆地去进行吧。
        <br />
      </div>
      <div class="title-child-bold">【知识巩固】</div>
      <div class="title-child-bold">练习25：生活中的AI</div>
      <div class="content">
        您如何看待AI在工作和日常生活中对您的影响？包括正面和可能的负面影响。
        <br />您的答案应至少为40个字
      </div>
   <div class="content" style="textAlign:center;">你的答案:<input type="text" class="anwserInput" :disabled="contenteditable"></div>

            <button class="sentBtn" style="marginLeft:290px;" @click="sentBtnOne">提交</button>


      <div class="title-child-bold">三、这不是结束，这只是一个开始</div>

      <div class="content">
        现在就这样。感谢您的加入。这对我们来说是一次伟大的尝试，我们真的希望你也喜欢它。我们的课程还没有结束，我相信我们永远不会结束。我们会不断更新和改进，使之成为最好的AI课程。
        <br />就像课程还没结束一样，你也不应该认为你对AI的探索已经结束了。这一领域的进展是相当迅速的，而且似乎有太多的事情需要跟踪，但令人欣慰的是，基本上在十年之后或多或少地会保持不变。只要你知道问题解决策略、处理不确定性和从数据中进行学习的基本知识，你就应该能够轻松地从新的角度看待AI问题。这就是为什么你必须画出小鸡过河、河内塔的图表，为什么你必须计算广州下雨的概率，或者用神经网络检测快乐的面孔。了解AI的基本原理或基础知识，比学习特定AI解决方案的技术细节要持久得多。
        <br />下面，我们给出一些参考资料或网站，请继续学习，保持好奇心！
        <br />1. 百度AI Studio
        <br />百度AI Studio课程为免费课程，由国内一线讲师打造，访问时要有百度账号。内容包括：深度学习，飞浆优势技术，中文NLP预训练模型，AI 快车道-图像语义分割，AI 快车道-推荐系统，AI 快车道-目标检测，等。
        <br />2. 网易公开课
        <br />网易公开课，实际上只是将麻省理工的“人工智能”课程搬上了163开放网站，不用注册，便于国人访问。内容包括22个视频。
        <br />3. 网易云课堂
        <br />网易云课堂包罗很广，这里选取的是人工智能与数据科学的内容，包括人工智能、数据科学、大数据、区块链、云计算等课程。
        <br />4. 学习强国APP
        <br />“学习强国”是一个手机在线学习平台（可免费下载），在学习强国APP中搜索“人工智能”，会显示很多有关人工智能的课程和资源，包括“人工智能原理”“人工智能与创新设计”“人工智能与信息社会”“人工神经网络”“人工智能：模型与算法”“Python人工智能编程”等通俗易懂的专题讲座。
        <br />……
        <br />5. 国外免费课程
        <br />这部分课程都在国外，且为英文，访问较慢，甚至很卡。
        <br />（1）Google AI： https://ai.google/education/#?modal_active=none
        <br />（2）Google - 深度学习（Deep Learning）：https://www.class-central.com/course/udacity-deep-learning-5681
        <br />（3）斯坦福大学 - 机器学习： https://www.coursera.org/learn/machine-learning
        <br />（4）哥伦比亚大学 - 机器学习：https://ai.google/education/#?modal_active=none
        <br />（5）Nvidia - 计算机视觉深度学习基础： https://www.class-central.com/course/fundamentals-of-deep-learning-for-computer-vision-10730
        <br />（6）麻省理工学院 - 自驾车的深度学习：https://selfdrivingcars.mit.edu/
        <br />
      </div>

      <div class="title-child-bold">完成第6章后，您应该能够：</div>

      <div class="content">
        •了解预测未来的困难，并能够更好地评估有关AI的主张
        <br />•识别AI的一些主要社会影响，包括算法偏差，AI生成的内容，隐私和工作
      </div>
    </div>

       <div class="backBtn" style="margin:20px auto;textAlign:center;">
        <button @click="goBlank" style="cursor: pointer;">上一页</button>
        <button @click="goMune"  style="marginLeft:15px;marginRight:15px;cursor: pointer;">返回目录页</button>
        <button @click="NextClk" style="cursor: pointer;">下一页</button>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textarea: "",
       contenteditable:false,
    };
  },
  created() {},
  computed: {},
  components: {},
  mounted() {},
  methods: {
     sentBtnOne(){
      this.contenteditable = true;
    },

        jumpOne(){
       this.$router.push('/lessonSixteen');
       
    },
    jumpTow(){
     this.$router.push('/lessonSeventeen');
    },
      
   
   
    jumpThree(){
      
       const returnEle = document.querySelector("#productId");  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        document.querySelector("counter1").scrollIntoView(true); //这里的counter1是将要返回地方的id
    },
    
    goBlank(){
      this.$router.push('/lessonSeventeen');
    },
    goMune(){
      this.$router.push('/');
    },
    NextClk(){
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.lessonTen {
  width: 100%;
}
.web_content {
  width: 650px;
  margin: 0 auto;
  padding: 0px 75px;
  background: #fff;
}
.title {
  font-size: 22px;
  color: #000;
  font-weight: bold;
  margin-top: 50px;
}
.content {
  text-indent: 2em;
  font-size: 16px;
  line-height: 35px;
}
.index {
  font-size: 16px;
  color: #0090ff;
  line-height: 15px;
}
.title-child {
  font-size: 22px;
  color: #000;
  margin-top: 30px;
}
.title-child-bold {
  font-size: 16px;
  color: #000;
  margin-top: 30px;

  font-weight: bold;
}

.content-red {
  color: #f15a23;
  font-size: 16px;
  line-height: 35px;
  text-indent: 2em;
}
.content-imgtext {
  margin-left: 40%;
}
.backBtn button{
  width: 100px;
}
</style>

















// WEBPACK FOOTER //
// src/components/lessonEighteen.vue